import { Component, OnInit, HostListener, NgZone, OnDestroy, AfterViewInit } from '@angular/core';
import { RdService } from 'src/app/services/rd.service';
import { IpService } from 'src/app/services/ip.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { userParam, asQueryString } from 'src/app/models/user-params-models';
import { DeviceDetectorService } from 'src/app/services/device-detector.service';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { rdResponse } from 'src/app/models/rd-models';
import { RdTokenService } from 'src/app/services/rd-token.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ScreenService } from '../screen/screen.service';
import { FormGroup, FormBuilder, Validators } from "@angular/forms"
import { VerisoulService } from 'src/app/services/verisoul.service';
// import { BureauService } from 'src/app/services/bureau.service';
import { Observable } from 'rxjs';
import { SURVEY_TRACKING_MESSAGES, SurveyTrackingMessageKey } from 'src/app/models/TrackUpdate';
import { environment } from 'src/environments/environment';
import { take, timeout } from 'rxjs/operators';
import { SurveyLandingTrackService } from 'src/app/services/survey-landing-track.service';
declare var $: any;

declare global {
  interface Window {
    DeviceIntelligence: any;
    __oeBootMark?: (step: string, extra?: any) => void;
  }
}

@Component({
  selector: 'app-survey-start',
  templateUrl: './survey-start.component.html',
  styleUrls: ['./survey-start.component.css'],
  host: {
    '[class.page-has-captcha]': 'throttleDescisionCode == 2'
  }
})



export class SurveyStartComponent implements OnInit, AfterViewInit, OnDestroy {
  showResearchDefender: boolean = true;
  ipAddress: string = '';
  rdResponseObject: rdResponse;
  errorMessage: string = '';
  isError: boolean = false;
  ips: string;
  isSubmitted: boolean = false; // Property to track submission
  isTermsChecked: boolean = true; // Track Terms and Conditions checkbox
  isPrivacyChecked: boolean = true; // Track Privacy Policy checkbox
  allChecked = true;
  isContinueButtonVisible: boolean = true;
  user_Message: string;
  userParam: userParam = {
    tforid: '0',
    utype: '0',
    qparm: '0',
    uid: '',
    rcid: '0',
    mode: 'Live',
    ip: '',
    devicetype: 0,
    policy: 1,
    tierid: 0,
    decisionCode: 0,
    serviceType: 0,
    activityToken: '',
    surveyId: 0,
  };

  NewUserParam = {
    sid: '',
    uid: '',
    transid: ''
  };
  TempUID: any;
  throttleDescisionCode: number;
  form: FormGroup;
  submittedRecaptcha: boolean = false;
  handleRDSecurityResponse: any;
  sessionId: string | null;
  fraudDetectionSessionId: string;
  isContinueClicked: boolean = false;
  private askingLeave = false;
  rdBlockNotice = '';
  dropoutDebugCount = 0;
  dropoutDebugLast = 'no send yet';

  constructor(private router: Router, private fb: FormBuilder, public rdTokenService: RdTokenService, private http: HttpClient, private route: ActivatedRoute, public rdInfoCheckService: RdService, private ipService: IpService, private deviceDetector: DeviceDetectorService, private scrnService: ScreenService, private verisoulService: VerisoulService,
    private zone: NgZone, private landingTrack: SurveyLandingTrackService) {
    this.form = this.fb.group({
      recaptcha: ['', Validators.required]
    });
  }

  blockNavigation = true;
  async ngOnInit(): Promise<void> {
    this.refreshDropoutDebug();

    if (typeof window.__oeBootMark === 'function') {
      window.__oeBootMark('start');
    }

    if (typeof window.__oeBootMark === 'function') {
      window.__oeBootMark('sql_hit');
    }
    this.rdInfoCheckService.logSurveyQuery(this.route.snapshot.queryParams).subscribe({
      next: () => {
        if (typeof window.__oeBootMark === 'function') {
          window.__oeBootMark('sql_ok', '200');
        }
      },
      error: (err) => {
        if (typeof window.__oeBootMark === 'function') {
          const status = err && err.status != null ? err.status : 0;
          const msg = (err && (err.statusText || err.message)) || 'unknown';
          window.__oeBootMark('sql_fail', 'http-' + status + ' ' + msg);
        }
        // Last chance if HttpClient still failed (http-0 / tab closing)
        this.flushSurveyQueryLogKeepalive();
      }
    });

    // or back button
    history.pushState(null, '', location.href);

    // handle OPT OUT
    window.addEventListener('triggerRejectAction', this.handleRejectEvent);

    await this.SetUserParams();
    // console.log('SetUserParams completed', this.userParam);
    localStorage.setItem('isSurveyRedirect', 'false');

    this.ipService.getIPAddresss().subscribe(
      async (res: any) => {
        this.userParam.ip = res.ip; // Store the IP
        // this.userParam.ip = '42.127.161.115';
        // this.userParam.ip = this.getRandomIP();

        this.getOrCreateUserId(this.userParam.ip);

        // Same pattern as UserActivityService: start exit listeners, then log landing
        this.landingTrack.startTracking(() => this.userParam);
        this.landingTrack.track(SURVEY_TRACKING_MESSAGES.LANDING_VIEW);

        //clickThrottle or Normal Behaviour
        if (this.userParam.tierid != 0) {
          this.clickThrottle();
        } else {
          this.surveyStart(1)
        }

      },
      (error) => {
        console.error('Failed to fetch IP address', error);
      }
    );


  }

  ngAfterViewInit(): void {
    setTimeout(() => this.initStartCarousel(), 50);
    window.addEventListener('resize', this.onCarouselResize);
  }

  private onCarouselResize = (): void => {
    this.refreshStartCarousel();
  };

  private shouldShowStartCarousel(): boolean {
    return window.innerWidth >= 768;
  }

  private initStartCarousel(): void {
    const $el = $('.start-page-carousel .owl-carousel');
    if (!$el.length || !this.shouldShowStartCarousel()) {
      return;
    }
    if ($el.data('owlCarousel')) {
      $el.data('owlCarousel').updateVars();
      return;
    }
    $el.owlCarousel({
      singleItem: true,
      autoPlay: 3500,
      stopOnHover: true,
      pagination: true,
      navigation: false,
      rewindNav: true,
      slideSpeed: 450,
      paginationSpeed: 400
    });
  }

  private destroyStartCarousel(): void {
    const $el = $('.start-page-carousel .owl-carousel');
    const owl = $el.data('owlCarousel');
    if (owl && typeof owl.destroy === 'function') {
      owl.destroy();
    }
    $el.removeData('owlCarousel');
    $el.removeData('owl-init');
    $el.removeClass('owl-loaded owl-hidden');
  }

  private refreshStartCarousel(): void {
    if (!this.shouldShowStartCarousel()) {
      this.destroyStartCarousel();
      return;
    }
    const $el = $('.start-page-carousel .owl-carousel');
    if ($el.data('owlCarousel')) {
      $el.data('owlCarousel').updateVars();
    } else {
      this.initStartCarousel();
    }
  }


  private SetUserParams(): Promise<void> {
    return new Promise((resolve, reject) => {

      this.route.queryParams.pipe(take(1)).subscribe(params => {
        if (Object.keys(params).length === 0) {
          this.isContinueButtonVisible = false;
          this.isSubmitted = true;
          this.user_Message = 'Invalid User';
          resolve();
          return;
        }

        // Helper for case-insensitive query param lookup
        const getParam = (key: string, defaultValue: any) => {
          const paramKey = Object.keys(params)
            .find(k => k.toLowerCase() === key.toLowerCase());

          return paramKey ? params[paramKey] : defaultValue;
        };

        // New URL
        this.NewUserParam.sid = getParam('sid', '0');
        this.NewUserParam.uid = getParam('uid', '');
        this.TempUID = getParam('uid', '');
        this.NewUserParam.transid = getParam('transid', '0');

        // Common
        this.userParam.mode = getParam('mode', 'Live');
        this.userParam.tierid = getParam('gr', 0);


        // Vendor answers
        this.rdInfoCheckService.ScripQ_VendorAns = Object.keys(params)
          .filter(key => /^\d+$/.test(key))
          .map(key => `${key}_${params[key]}`);

        // New URL flow
        if (
          this.NewUserParam.sid !== '0' &&
          this.NewUserParam.transid !== '0'
        ) {

          this.RedirectToStandardLink(this.NewUserParam)
            .then(() => resolve())
            .catch(err => reject(err));

          return;
        }

        // Old URL flow
        this.userParam.utype = getParam('utype', '0');
        this.userParam.tforid = getParam('tforid', '0');
        this.userParam.qparm = asQueryString(getParam('qparm', ''), '');
        this.userParam.rcid = getParam('rcid', '0');
        this.userParam.uid = getParam('uid', '');
        resolve();
      });
    });
  }


  @HostListener('window:popstate')
  onPopState(): void {
    if (!this.blockNavigation) {
      return;
    }
    history.pushState(null, '', location.href);
    this.askBeforeLeave();
  }

  /** Close / refresh — this is the only place browsers allow a native leave dialog. */
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): string | void {
    if (!this.landingTrack.isLeavePromptActive() || !this.landingTrack.hasUserEngagement()) {
      return;
    }
    event.preventDefault();
    event.returnValue = '';
    return '';
  }

  /**
   * OK = leave (Dropout). Cancel = stay.
   * Only used for Back — that is a real user click, so confirm() is allowed.
   */
  private askBeforeLeave(): void {
    if (!this.landingTrack.isLeavePromptActive() || this.askingLeave) {
      return;
    }
    this.askingLeave = true;
    const wantsToLeave = window.confirm(
      'Are you sure you want to leave this survey?\nIf you leave now, your progress will be lost and you may not get this survey again.'
    );
    this.askingLeave = false;
    if (!wantsToLeave) {
      return;
    }
    this.blockNavigation = false;
    this.landingTrack.sendDropoutCallback();
    this.landingTrack.disableLeavePrompt();
  }


  private buildTrackingMessage(
    key: SurveyTrackingMessageKey,
    params?: { status?: number }
  ): string {

    let message: string = SURVEY_TRACKING_MESSAGES[key];

    if (params?.status !== undefined) {
      message = message.replace('{status}', String(params.status));
    }

    return message;
  }


  private async sendAndMarkSent(
    key: SurveyTrackingMessageKey,
    logId: any,
    mode: any,
    params?: { status?: number }
  ): Promise<void> {

    const message: string = this.buildTrackingMessage(key, params);
    this.landingTrack.markIntentionalExit();
    try {
      await fetch(`${environment.baseUrl}callbacks/TrackUpdate`, {
        method: 'POST',
        body: JSON.stringify({ toid: logId, message, mode }),
        headers: { 'Content-Type': 'application/json' },
        keepalive: true
      });
    } catch {
      // do nothing — redirect should still happen
      try {
        this.landingTrack.track(SURVEY_TRACKING_MESSAGES.ERROR_IN_TrackUpdate);
      } catch { }
    }
  }


  // Define a class property arrow function
  handleRejectEvent = () => {
    this.onReject();
  }

  continueToggle() {
    this.isContinueClicked = true
    this.onSubmit();
  }

  getRandomIP(): string {
    return Array.from({ length: 4 }, () => Math.floor(Math.random() * 256)).join('.');
  }


  getOrCreateUserId(ip: string): string {


    const ipInt = this.ipToInteger(ip);
    const rawUserId = String(ipInt);

    this.ipService.userId = rawUserId;
    return rawUserId;
  }


  ipToInteger(ipAddress: string): number {
    const parts = ipAddress.split('.');

    if (parts.length !== 4) {
      throw new Error("Invalid IP address format");
    }

    const A = Number(parts[0]); // PARSENAME(...,4)
    const B = Number(parts[1]); // PARSENAME(...,3)
    const C = Number(parts[2]); // PARSENAME(...,2)
    const D = Number(parts[3]); // PARSENAME(...,1)

    return (A * 256 * 256 * 256) +
      (B * 256 * 256) +
      (C * 256) +
      D;
  }

  private RedirectToStandardLink(Newparam: any): Promise<void> {
    return new Promise((resolve, reject) => {

      this.rdInfoCheckService.getSurveyStandardLink(Newparam).subscribe({

        next: (response: any) => {

          if (response?.data) {
            try {

              const url = new URL(response.data);
              const params = url.searchParams;

              const getParam = (key: string, defaultValue: string = '') => {
                let value = defaultValue;
          
                params.forEach((paramValue, paramKey) => {
                  if (paramKey.toLowerCase() === key.toLowerCase()) {
                    value = paramValue;
                  }
                });
          
                return value;
              };
          
              this.userParam.utype = getParam('utype', '0');
              this.userParam.tforid = getParam('tforid', '0');
              this.userParam.qparm = asQueryString(getParam('qparm', ''), '');
              this.userParam.rcid = getParam('rcid', '0');
              this.userParam.uid = this.TempUID;
              resolve();

            } catch (e) {

              this.user_Message = 'Failed to parse response URL.';
              this.rdInfoCheckService.isProcessing = false;
              this.isContinueButtonVisible = false;
              this.isContinueClicked = false;
              this.isSubmitted = true;

              reject(e);
            }

          } else {

            this.user_Message = 'No link found to process.';
            this.rdInfoCheckService.isProcessing = false;
            this.isContinueButtonVisible = false;
            this.isContinueClicked = false;
            this.isSubmitted = true;

            reject('No link found');
          }
        },

        error: (error: any) => {

          this.user_Message =
            error?.error?.data?.message || 'An error occurred.';

          this.rdInfoCheckService.isProcessing = false;
          this.isContinueButtonVisible = false;
          this.isContinueClicked = false;
          this.isSubmitted = true;

          reject(error);
        }
      });
    });
  }

  surveyStart(policy: number): void {
    this.errorMessage = undefined;
    // Get the device type
    this.userParam.devicetype = this.deviceDetector.getDeviceType();
    // Get the user's IP address
    this.userParam.policy = policy;
    this.userParam.decisionCode = this.throttleDescisionCode;
    // this.rdInfoCheckService.isProcessing = true;

    this.checkRDServiceType(policy);


  }


  async checkRDServiceType(policy: number): Promise<void> {
    this.errorMessage = undefined;

    this.userParam.devicetype = this.deviceDetector.getDeviceType();
    this.userParam.policy = policy;
    this.userParam.decisionCode = this.throttleDescisionCode;
    const rdServiceTypeUrl = this.rdInfoCheckService.getServiceType();

    try {
      const serviceTypeResp = await this.rdInfoCheckService.postData(this.userParam, rdServiceTypeUrl).toPromise();

      const serviceType = serviceTypeResp.body?.data?.serviceType;
      this.userParam.serviceType = serviceType;
      // this.userParam.serviceType = 2; //TEMP
      this.userParam.surveyId = serviceTypeResp.body?.data?.surveyId;

      await this.handleServiceType(serviceType);
      // this.isBureauRun ? 2 : serviceType
    } catch (error: any) {
      console.error("Error in checkRDServiceType:", error);
      this.landingTrack.track(SURVEY_TRACKING_MESSAGES.ERROR_IN_SERVICE_TYPE);
    }
  }

  private async handleServiceType(serviceType: number): Promise<void> {
    // if (serviceType === 2) {
    //   try {
    //     const sessionId = await this.bureauService.getSessionId().toPromise();
    //     this.fraudDetectionSessionId = sessionId.eventId;
    //   } catch (error) {
    //     console.error('Bureau SDK failed:', error);
    //   }
    //   setTimeout(() => {
    //     this.triggerRDSecurityCheck();
    //   }, 500);
    // } else
    if (serviceType === 3) {
      this.fraudDetectionSessionId = await this.verisoulService.getVerisoulSessionId();
      setTimeout(() => {
        this.triggerRDSecurityCheck();
      }, 500);
    }
    // else if (serviceType === 4) {
    //   this.fraudDetectionSessionId = this.userParam.ip;
    //   await this.triggerRDSecurityCheck();
    // }
    else {
      // Unknown / missing service type — do not leave user frozen on LANDING_VIEW only
      console.error('Unsupported serviceType:', serviceType);
      this.landingTrack.track(SURVEY_TRACKING_MESSAGES.ERROR_IN_SERVICE_TYPE);
      this.user_Message = 'Unable to start security check. Please try again.';
      this.isContinueButtonVisible = false;
      this.isSubmitted = true;
      this.rdInfoCheckService.RdResponsedone = true;
    }
  }

  private async triggerRDSecurityCheck(): Promise<void> {
    await this.getRDSecurityCheck();
  }

  async getRDSecurityCheck(): Promise<void> {
    try {
      this.rdInfoCheckService.RdResponsedone = false;
      const rdInfoUrl = this.rdInfoCheckService.getRdInfoUrl();
      this.userParam.activityToken = this.fraudDetectionSessionId;

      const response = await this.rdInfoCheckService.postData(this.userParam, rdInfoUrl).toPromise();
      const rdBodyMsg = response.body?.message || response.body?.data?.message || '';
      this.landingTrack.track(`InProgress-Yoda-Rd response - ${response.status} - ${rdBodyMsg}`);
      this.handleRDSecurityResponse = response;
      this.rdInfoCheckService.RdResponsedone = true;
      this.rdInfoCheckService.doRedirect = response.body?.data?.doRedirect;
      this.rdInfoCheckService.statusCode = response.status;

      if (response.status !== 200) {
        throw response;
      }
      if (!this.rdInfoCheckService.doRedirect) {
        this.landingTrack.enableLeavePrompt();
      } else {
        this.landingTrack.disableLeavePrompt();
      }
      await this.handleFraudDetection();
      this.isSubmitted = true;

    } catch (error) {
      this.rdInfoCheckService.RdResponsedone = true;
      this.handleError(error as HttpErrorResponse);
      const status = error?.status || null;
      if (status !== 202) {
        this.landingTrack.track(SURVEY_TRACKING_MESSAGES.ERROR_IN_RDINFO + ' - ' + this.rdCallErrorText(error));
      }
    }
  }

  private getStatusFromCallbackUrl(url: string): number | null {
    try {
      const parsedUrl = new URL(url);
      const status = parsedUrl.searchParams.get('s');
      return status ? Number(status) : null;
    } catch {
      return null;
    }
  }

  private isAbsoluteHttpUrl(url: string): boolean {
    try {
      const parsed = new URL(url);
      return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
      return false;
    }
  }

  /** location.href is not popup-blocked; if the document never unloads, treat as failed redirect. */
  private assignScreenerLocationOrFallback(url: string, onStillHere: () => void): void {
    let pageStartedLeaving = false;
    const markLeaving = () => { pageStartedLeaving = true; };
    window.addEventListener('pagehide', markLeaving, { once: true });
    window.addEventListener('beforeunload', markLeaving, { once: true });
    try {
      window.location.assign(url);
    } catch {
      onStillHere();
      return;
    }
    setTimeout(() => {
      if (!pageStartedLeaving && document.visibilityState === 'visible') {
        onStillHere();
      }
    }, 5000);
  }


  private async handleError(error: any): Promise<void> {
    const data = error?.error?.data || error?.body?.data || null;
    if (!data || !data.doRedirect) {
      this.user_Message = data?.message || 'Unable to continue. Please try again.';
      this.rdInfoCheckService.isProcessing = false;
      this.isContinueButtonVisible = false;
      this.isContinueClicked = false;
      this.isSubmitted = true;
      this.throttleDescisionCode = 5;
      return;
    }
    const CallbackUrl = data.redirectLink;
      // this.store_Get_RedirectLink(data.redirectLink);
      // 🔽 Extract status from ?s=10
      const status = this.getStatusFromCallbackUrl(CallbackUrl);
      this.landingTrack.markIntentionalExit();
      localStorage.setItem('isSurveyRedirect', 'true');
      if (CallbackUrl.includes('survey/survey-callback')) {

        const url = new URL(CallbackUrl);
        const queryParams: any = {};

        url.searchParams.forEach((value, key) => {
          queryParams[key] = value;
        });
        // Add or override 'ref' param
        queryParams['ref'] = 'y';

        this.router.navigate(
          ['survey/survey-callback'],
          { queryParams }
        );

      } else {
        window.location.href = CallbackUrl;
      }
  }

  private async handleFraudDetection(): Promise<void> {
    this.fraudDetectionSessionId = await this.verisoulService.getVerisoulSessionId();
    // Bureau (serviceType 2), paused while backend always sends 3:
    // const sessionId = await this.bureauService.getSessionId().toPromise();
    // this.fraudDetectionSessionId = sessionId.eventId;
  }

  RedirectLink: string;
  store_Get_RedirectLink(redirectLink: any) {
    this.RedirectLink = redirectLink;
  }

  goToSurveyStart() {
    localStorage.setItem('isContinueButtonVisible', JSON.stringify(this.isContinueButtonVisible));
    this.isContinueButtonVisible = false;

  }
  // Method to handle the API response
  handleResponse(response: any): void {
    if (response.status === 200) {

      this.rdResponseObject = { rdSearch: null, activityToken: '', serviceType: 0, surveyInfo: null, queryParams: this.rdInfoCheckService.ScripQ_VendorAns };
      this.rdResponseObject.surveyInfo = this.rdInfoCheckService.toObject(response.body).surveyInfo; // change toObject for service type
      const runRdSearch = response.body.surveyInfo.rdAPIInfo.isrunRDsearch == 1;
      const runRdActivity = response.body.surveyInfo.rdAPIInfo.isrunRDactivity == 1;
      this.rdInfoCheckService.onRdScriptRetry = () => {
        this.rdBlockNotice = 'Retrying to load the required information. Please wait...';
        this.rdInfoCheckService.isProcessing = true;
      };
      this.rdInfoCheckService.loadAndFetchTrackingData(response.body.surveyInfo.surveyId, response.body.surveyInfo.country, this.userParam.tforid,
        response.body.surveyInfo.rdAPIInfo.isrunRDsearch).pipe(timeout(15000)).subscribe({
          next: (g: any) => {
          this.rdBlockNotice = '';
          if (runRdSearch) {
            this.landingTrack.track('InProgress-Yoda-Rd search - success');
          }

          this.rdResponseObject.rdSearch = g == undefined ? null : this.rdInfoCheckService.toObject(g).rdSearch
          if (this.rdResponseObject.rdSearch != null || this.rdResponseObject.rdSearch != undefined) {
            this.rdResponseObject.rdSearch.Surveys[0].Days_difference =
              this.rdResponseObject.rdSearch.Surveys[0].Days_difference == null ? 0 :
                this.rdResponseObject.rdSearch.Surveys[0].Days_difference;
            this.rdResponseObject.rdSearch.Surveys[0].Days_flag =
              this.rdResponseObject.rdSearch.Surveys[0].Days_flag == null ? 0 :
                this.rdResponseObject.rdSearch.Surveys[0].Days_flag;
          }
          this.rdTokenService.getToken(response.body.surveyInfo.rdAPIInfo.isrunRDactivity).pipe(timeout(15000)).
            subscribe({
              next: (t: any) => {
              if (runRdActivity) {
                this.landingTrack.track('InProgress-Yoda-Rd activity - success');
              }

              const startUrl = this.rdInfoCheckService.getStartUrl();

              this.rdInfoCheckService.postData(this.rdResponseObject, startUrl).pipe(timeout(15000)).subscribe({
                next: async (response: HttpResponse<any>) => {
                  const startBodyMsg = response.body?.message || response.body?.data?.message || '';
                  this.landingTrack.track(`InProgress-Yoda-Start response - ${response.status} - ${startBodyMsg}`);
                  if (response.status === 200) {
                    const newKey = `lId_${this.userParam.tforid}_${this.userParam.utype}`;
                    // Object.keys(localStorage).forEach(key => {
                    //   if (key.startsWith('lId_')) {
                    //     localStorage.removeItem(key);
                    //   }
                    // });
                    localStorage.setItem(newKey, response.body.data.logId);
                    this.scrnService.LogId = response.body.data.logId;
                    this.scrnService.Mode = response.body.data.mode;
                    this.scrnService.ClientUrl = response.body.data.redirectLink;
                    const CallbackUrl = response.body.data.redirectLink
                    if (response.body.data.isScreener) {
                      const screenerUrl = response.body.data?.screenerUrl;
                      const surveyLogId = response.body.data?.surveyLogId;
                      const logId = response.body.data.logId;
                      const mode = response.body.data.mode;

                      if (!surveyLogId) {
                        this.landingTrack.track(SURVEY_TRACKING_MESSAGES.ERROR_SURVEY_LOG_ID);
                      }

                      const goCallbackScreenerFail = (message: string) => {
                        this.landingTrack.track(message);
                        this.landingTrack.markIntentionalExit();
                        if (!surveyLogId) {
                          return;
                        }
                        localStorage.setItem('isSurveyRedirect', 'true');
                        this.router.navigate(
                          ['survey/survey-callback'],
                          { queryParams: { TOID: surveyLogId, s: 9, ref: 'y' } }
                        );
                      };

                      if (!screenerUrl || !String(screenerUrl).trim()) {
                        goCallbackScreenerFail(SURVEY_TRACKING_MESSAGES.ERROR_SCREENER_LINK);
                      } else if (screenerUrl === '/survey/attempt-survey') {
                        try {
                          await this.sendAndMarkSent('REDIRECT_TO_OLD_SCREENER', logId, mode);
                          localStorage.setItem('isSurveyRedirect', 'true');
                          const navOk = await this.router.navigate([screenerUrl]);
                          if (navOk === false) {
                            goCallbackScreenerFail(SURVEY_TRACKING_MESSAGES.ERROR_SCREENER_REDIRECT);
                          }
                        } catch {
                          goCallbackScreenerFail(SURVEY_TRACKING_MESSAGES.ERROR_SCREENER_REDIRECT);
                        }
                      } else if (!this.isAbsoluteHttpUrl(screenerUrl)) {
                        goCallbackScreenerFail(SURVEY_TRACKING_MESSAGES.ERROR_SCREENER_LINK);
                      } else {
                        try {
                          await this.sendAndMarkSent('REDIRECT_TO_SCREENER', logId, mode);
                          localStorage.setItem('isSurveyRedirect', 'true');
                          this.assignScreenerLocationOrFallback(screenerUrl, () => {
                            goCallbackScreenerFail(SURVEY_TRACKING_MESSAGES.ERROR_SCREENER_REDIRECT);
                          });
                        } catch {
                          goCallbackScreenerFail(SURVEY_TRACKING_MESSAGES.ERROR_SCREENER_REDIRECT);
                        }
                      }
                    }
                    else if (!response.body.data.isScreener && response.body.data.doRedirect == true && response.body.data.redirectLink != '') {
                      const messageKey = CallbackUrl.includes('survey/survey-callback')
                        ? 'REDIRECT_TO_CALLBACK'
                        : 'REDIRECT_TO_CLIENT';

                      const status = this.getStatusFromCallbackUrl(CallbackUrl);
                      try {
                        await this.sendAndMarkSent(messageKey, response.body.data.logId, response.body.data.mode, messageKey === 'REDIRECT_TO_CALLBACK' ? { status } : undefined);
                      } catch { }

                      localStorage.setItem('isSurveyRedirect', 'true');
                      // window.location.href = response.body.data.redirectLink;
                      if (CallbackUrl.includes('survey/survey-callback')) {

                        const url = new URL(CallbackUrl);
                        const queryParams: any = {};

                        url.searchParams.forEach((value, key) => {
                          queryParams[key] = value;
                        });

                        // Add or override 'ref' param
                        queryParams['ref'] = 'y';

                        this.router.navigate(
                          ['survey/survey-callback'],
                          { queryParams }
                        );

                      } else {
                        window.location.href = CallbackUrl;
                      }
                    }
                    else {
                      // Start API: no screener / no redirect — log same message shown on screen
                      this.user_Message = response.body.data.message;
                    }
                  } else if (response.status !== 202) {
                    this.user_Message = response.body?.data?.message || response.body?.message || '';
                    this.rdInfoCheckService.isProcessing = false;
                    this.landingTrack.track(SURVEY_TRACKING_MESSAGES.ERROR_IN_START + ' - ' + response.status + ' - ' + (this.user_Message || 'Message not found'));
                    this.landingTrack.enableLeavePrompt();
                  }
                },
                error: (error: HttpErrorResponse) => {
                  this.user_Message = error?.error?.data?.message || error?.error?.message || '';
                  this.rdInfoCheckService.isProcessing = false;
                  this.isContinueButtonVisible = false;
                  this.isContinueClicked = false;
                  this.isSubmitted = true;
                  if (error?.status !== 202) {
                    this.landingTrack.track(SURVEY_TRACKING_MESSAGES.ERROR_IN_START + ' - ' + this.rdCallErrorText(error));
                    this.landingTrack.enableLeavePrompt();
                  }

                }
              });
            },
              error: (error) => {
                this.rdInfoCheckService.isProcessing = false;
                this.landingTrack.track('InProgress-Yoda-Rd activity - error - ' + this.rdCallErrorText(error));
                this.redirectAfterRdDropout();
              }
            });
        },
          error: (error) => {
            this.rdInfoCheckService.isProcessing = false;
            this.landingTrack.track('InProgress-Yoda-Rd search - error - ' + this.rdCallErrorText(error));
            this.redirectAfterRdDropout();
          }
        });
    } else {
      // RD security check non-200 — screen message only, no temp log here
      this.user_Message = response.body.data.message;
    }
  }

  private async redirectAfterRdDropout(): Promise<void> {
    try {
      await this.landingTrack.requestDropoutToid();
      this.landingTrack.markIntentionalExit();
    } catch (e) {
      this.landingTrack.track('InProgress-Yoda-Dropout response - error - ' + (e && e.message ? e.message : 'failed'));
      this.landingTrack.enableLeavePrompt();
    }
    this.showRdBrowserBlockedMessage();
  }

  private showRdBrowserBlockedMessage(): void {
    this.user_Message = 'Required Security Check is not allowed';
    this.isContinueButtonVisible = false;
    this.rdInfoCheckService.isProcessing = false;
    this.isSubmitted = true;
    this.rdBlockNotice = 'We could not continue because your browser blocked a required security check. Please allow scripts for this site, or open the survey in another browser.';
    setTimeout(() => {
      this.rdBlockNotice = '';
    }, 8000);
  }

  private rdCallErrorText(error: any): string {
    const status = error?.status != null && error.status !== 0 ? String(error.status) : '';
    const body = error?.error;
    const httpBody = error?.body;
    const msg = (typeof body === 'string' && body.trim()) ? body
      : (body?.message
        || body?.data?.message
        || httpBody?.message
        || httpBody?.data?.message
        || error?.message
        || error?.statusText
        || 'unknown');
    const text = String(msg).replace(/\s+/g, ' ').slice(0, 180);
    return status ? `${status} - ${text}` : text;
  }

  // Method to get information for RD security check
  getInfo(tforid: string, utype: string): void {

    this.rdInfoCheckService.getInfoForRDSecurityCheck(tforid, utype).subscribe(
      response => {
        console.log('API response:', response);
      },
      error => {
        console.error('API error:', error);
      }
    );
  }

  onSubmit(): void {
    this.landingTrack.track(SURVEY_TRACKING_MESSAGES.CONTINUE_CLICKED);

    this.rdInfoCheckService.isProcessing = true;
    if (this.isTermsChecked && this.isPrivacyChecked) {
      if (this.userParam.tierid == 0) {
        this.landingTrack.disableLeavePrompt();
        this.handleResponse(this.handleRDSecurityResponse)
      } else {
        this.submittedRecaptcha = true;
        if (this.form.invalid && this.throttleDescisionCode == 2) {
          this.rdInfoCheckService.isProcessing = false;
          return;
        }

        this.rdInfoCheckService.isProcessing = true;
        this.landingTrack.disableLeavePrompt();
        this.handleResponse(this.handleRDSecurityResponse)

      }

    }
    else {
      this.rdInfoCheckService.isProcessing = false;
      this.isError = true;
      this.errorMessage = 'please select terms of service'
    }
  }

  get invalidFormCheck(): boolean {
    return this.throttleDescisionCode == 2 && this.form.invalid;
  }


  clickThrottle() {
    const payload = {
      tforid: this.userParam.tforid,
      teirId: Number(this.userParam.tierid),
      timestamp: this.getCurrentDateTime()
    }

    this.scrnService.throttleCheck(payload).subscribe({
      next: (resp) => {

        this.throttleDescisionCode = resp.body.decisionCode;
        if (resp.body.decisionCode == 0 || resp.body.decisionCode == 1) {
          this.checkRDServiceType(1);
        } else if (resp.body.decisionCode == 3 || resp.body.decisionCode == 4) {
          this.surveyStart(1);
        } else if (resp.body.decisionCode == 2) {
          this.checkRDServiceType(1);
        } else {
          this.landingTrack.markIntentionalExit();
          this.router.navigate(['not-found'])
        }

      },
      error: (err) => {
        console.log("Error while fetching", err);
        this.landingTrack.track(SURVEY_TRACKING_MESSAGES.ERROR_IN_CLICK_THROTTLE);

      }
    })
  }

  //recapcha validation
  onCaptchaResolved(token: string | null) {
    console.log('Captcha resolved:', token);
    this.form.get('recaptcha')?.setValue(token);
  }

  onRecaptchaSubmit() {
    this.submittedRecaptcha = true;
    if (this.form.valid) {
      console.log("inside valid")
      this.throttleDescisionCode = 5;
    }
  }

  getCurrentDateTime(): string {
    const currentDateTime = new Date().toISOString();
    return currentDateTime.substring(0, currentDateTime.length - 1) + 'Z'
  }

  // Method to handle reject terminate
  onReject() {
    this.rdInfoCheckService.isProcessing = true;
    this.landingTrack.track(SURVEY_TRACKING_MESSAGES.OPT_OUT);
    if (!this.RedirectLink) {
      const response = this.handleRDSecurityResponse;
      if (!response?.body?.surveyInfo) {
        console.error("Invalid response object", response);
        this.rdInfoCheckService.isProcessing = false;
        return;
      }

      this.landingTrack.markIntentionalExit();
      const updatedResponse = {
        ...response,
        body: {
          ...response.body,
          surveyInfo: {
            ...response.body.surveyInfo,
            policy: 0
          }
        }
      };
      this.handleResponse(updatedResponse);
    } else {
      this.landingTrack.markIntentionalExit();
      this.landingTrack.track(SURVEY_TRACKING_MESSAGES.REDIRECT_TO_CALLBACK);
      localStorage.setItem('isSurveyRedirect', 'true');

      if (this.RedirectLink.includes('survey/survey-callback')) {

        const url = new URL(this.RedirectLink);
        const queryParams: any = {};

        url.searchParams.forEach((value, key) => {
          queryParams[key] = value;
        });
        // Add or override 'ref' param
        queryParams['ref'] = 'y';

        this.router.navigate(
          ['survey/survey-callback'],
          { queryParams }
        );

      } else {
        window.location.href = this.RedirectLink;
      }
    }
  }

  // Method to open a document in a new browser tab based on the document type
  OpenDoc(type: string): void {
    // Opening PDF can hide this tab — don't treat as dropout
    this.landingTrack.pauseExitLogging(4000);
    let filePath = '';
    if (type === 'terms') {
      filePath = 'file-sample.pdf';
    } else if (type === 'privacy') {
      filePath = 'file-sample.pdf';
    }
    const fullUrl = window.location.origin + '/assets/documents/' + encodeURI(filePath);
    window.open(fullUrl, '_blank');
  }
  // Method to determine if the submit button should be disabled
  isSubmitDisabled(): boolean {
    return !(this.isTermsChecked && this.isPrivacyChecked);
  }

  //new
  IsChecked(event: Event, type: string) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (type === 'terms') {
      this.isTermsChecked = isChecked;
    } else if (type === 'privacy') {
      this.isPrivacyChecked = isChecked;
    }
    if (this.isTermsChecked && this.isPrivacyChecked) {
      this.isError = false;
    } else {
      this.isError = true;
    }
    // Update the 'Select All' checkbox state based on individual checkboxes
    this.allChecked = this.isTermsChecked && this.isPrivacyChecked;

    // Clear the error message if both checkboxes are checked
    if (this.isTermsChecked && this.isPrivacyChecked) {
      this.errorMessage = undefined;
    }
  }

  // for select all
  toggleAll(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.isTermsChecked = isChecked;
    this.isPrivacyChecked = isChecked;
    this.allChecked = isChecked;

    // Clear the error message if both checkboxes are checked
    if (this.isTermsChecked && this.isPrivacyChecked) {
      this.isError = false;
    } else {
      this.isError = true;
    }
  }

  // Kept for any leftover callers — routes through landing track service
  async saveSurveyUserTempData(pageName?: string): Promise<void> {
    if (pageName) {
      this.landingTrack.track(pageName);
    }
  }

  // User activity → reset inactivity timer in track service
  @HostListener('window:mousemove') @HostListener('window:keydown')
  @HostListener('window:touchstart') @HostListener('window:click')
  @HostListener('window:scroll')
  onActivity(): void {
    this.landingTrack.onUserActivity();
  }

  /** Actual Start-API log id value (not the localStorage key). */
  get getLogId(): string | null {
    const key = `lId_${this.userParam.tforid}_${this.userParam.utype}`;
    return localStorage.getItem(key);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onCarouselResize);
    this.destroyStartCarousel();
    window.removeEventListener('triggerRejectAction', this.handleRejectEvent);
    this.landingTrack.stopTracking();
    this.flushSurveyQueryLogKeepalive();
  }

  @HostListener('document:visibilitychange')
  onVisibilityForDropoutDebug(): void {
    if (document.visibilityState === 'visible') {
      this.refreshDropoutDebug();
    }
  }

  private refreshDropoutDebug(): void {
    const debug = this.landingTrack.getDropoutDebug();
    this.dropoutDebugCount = debug.count;
    this.dropoutDebugLast = debug.lastText;
  }

  clearDropoutDebug(): void {
    this.landingTrack.clearDropoutDebug();
    this.refreshDropoutDebug();
  }

  /** If sql_ok never arrived, send one keepalive GET so the user is not a backend ghost. */
  private flushSurveyQueryLogKeepalive(): void {
    const marks = (window as any).__oeBoot && (window as any).__oeBoot.marks
      ? (window as any).__oeBoot.marks
      : [];
    if (marks.indexOf('sql_ok') !== -1) {
      return;
    }
    const url = this.rdInfoCheckService.surveyQueryLogFullUrl(this.route.snapshot.queryParams);
    try {
      if (typeof fetch === 'function') {
        fetch(url, { method: 'GET', keepalive: true, cache: 'no-store' }).catch(function () { });
      }
    } catch (e) { }
  }


}
